/* eslint-disable react/no-unused-state */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack';
import Panel from '../../../components/panel';
import Loading from '../../../components/loading/loading';
import styles from '../../workorders/Detail/workOrderDetail.module.scss';
import icon from '../../../icons/GateModule.png';
import { getGateRequest, clearData } from '../redux/actions';
import { renderInfoForType } from '../../../utils/helpers';

class RequestDetail extends Component {
  state = {
    loadingStatus: false,
    modal: false,
    ActionDropdown: false
  };

  componentDidMount() {
    const {
      actionFetch,
      match: {
        params: { id }
      }
    } = this.props;
    actionFetch(id);
  }

  componentWillUnmount() {
    const { ClearAction } = this.props;
    ClearAction();
  }

  render() {
    const {
      gateRequest
    } = this.props;
    const {
      loadingStatus
    } = this.state;
    const arrivalTypes = {
      'domestic': 'Domestic',
      'international': 'International'
    };


    let fields = [];
    if (gateRequest) {
      fields = [
        { 'id': 'gate.new.reported_by', 'default_message': 'Requested by', 'value': gateRequest?.logged_by?.fullname },
        { 'id': 'gate.new.submission_date',
          'default_message': 'Requested Date',
          'value': renderInfoForType({ type: 'datetime' }, gateRequest.requested_date, null, null)
        },
        { 'id': 'gate.form.airline', 'default_message': 'Airline', 'value': gateRequest.airline?.name },
        { 'id': 'gate.form.flight_no', 'default_message': 'Flight #', 'value': gateRequest.flight_number },
        { 'id': 'gate.form.depart_airport', 'default_message': 'Departure Airport', 'value': gateRequest.dept_airport },
        {
          'id': 'gate.form.arrival_time',
          'default_message': 'Arrival Date',
          'value': renderInfoForType({ type: 'datetime' }, gateRequest.arrival_date, null, null)
        },
        { 'id': 'gate.form.aircraft', 'default_message': 'Aircraft', 'value': gateRequest?.aircraft },
        { 'id': 'gate.form.arrival_type', 'default_message': 'Arrival Type', 'value': arrivalTypes?.[gateRequest.arrival_type] },
        {
          'id': 'gate.form.in_date',
          'default_message': 'Requested In-Block Time',
          'value': renderInfoForType({ type: 'datetime' }, gateRequest.in_date, null, null)
        },
        {
          'id': 'gate.form.off_date',
          'default_message': 'Requested Off-Block Time',
          'value': renderInfoForType({ type: 'datetime' }, gateRequest.from_date, null, null)
        },
        { 'id': 'gate.form.remarks', 'default_message': 'Remarks', 'value': gateRequest.remarks, 'fullWidth': true }
      ];

      if (gateRequest?.to_gate) {
        fields.push(
          {
            'id': 'gate.form.requested_gate',
            'default_message': 'Requested Gate',
            'value': gateRequest?.to_gate,
            'fullWidth': true
          }
        );
      }

      if (gateRequest?.info?.rejected?.comment) {
        fields.push(
          {
            'id': 'gate.form.rejected_comments',
            'default_message': 'Reason for Rejected',
            'value': gateRequest?.info?.rejected?.comment,
            'fullWidth': true
          }
        );
      }
    }

    return (
      <>
        <SectionHeader
          icon={icon}
          translationID="shortcuts.gate_change"
          defaultTitle="Gate Change Request"
        />
        {!gateRequest && <Loading loadingStatus={loadingStatus} />}
        <HeaderBack
          translationID="workorder.settings.back"
          translationDefault="Back"
          backRoute="/gate_change"
        />
        <div className="container">
          <Panel
            containerClasses={styles.mainPanel}
            title="gateRequest.detail"
            defaultTitle="Gate Change Request Details"
          >
            {gateRequest && (
              <>
                <div className={styles.panelContent}>
                  <div className={styles.stepInfo} style={{ marginTop: '10px' }}>
                    {fields?.map(field => (
                      <div className={field?.fullWidth ? styles.infoFull : styles.infoHalf}>
                        <span className={styles.title}>
                          <FormattedMessage
                            id={field?.id}
                            defaultMessage={field?.default_message}
                          />
                        </span>
                        <p className={styles.rowContent}>
                          {field?.value}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </Panel>
        </div>
      </>
    );
  }
}

RequestDetail.propTypes = {
  match: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  gateRequest: state.gate.gateRequest
});

const mapDispatchToProps = dispatch => ({
  actionFetch: (id) => {
    dispatch(getGateRequest(id));
  },
  ClearAction: () => {
    dispatch(clearData());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestDetail);
